export default __webpack_public_path__ + "static/media/icon_abandon.07b443d9.png";